/**
 * @prettier
 * @author Alexander Nagelberg
 * @since 24.3
 */
//@ts-check
export enum SettingFieldType {
  StaticText = 'STATIC_TEXT',
  TextArea = 'TEXT_AREA',
  TextBox = 'TEXT_BOX',
  CheckBox = 'CHECK_BOX',
  MultiChoice = 'MULTI_CHOICE'
}
